import api from '../library/axios';
// import config from '../config';

export default {
  getList() {
    return api({
      url: '/api/resellers',
    });
  },
  save({ form }) {
    return api({
      url: '/api/resellers',
      method: 'post',
      data: form,
    });
  },
};
